import React, { useMemo } from 'react';

import { Container, Text } from './styles';

import packageJson from '../../../../package.json';

const Footer = () => {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <Container>
      <Text>Copyright © {year} Augenmobil AG</Text>
      <Text>Release {packageJson.version}</Text>
    </Container>
  );
};

export default Footer;
